<template>
  <div class="h-1.5 overflow-hidden rounded-full bg-grey">
    <div
      class="h-full w-full rounded-full bg-current transition-transform duration-500"
      :style="{
        transform: `translate3d(-${translateX}%, 0, 0)`,
      }"
    />
  </div>
</template>

<script setup lang="ts">
interface BaseProgressBarProps {
  progress?: number
}

const props = withDefaults(defineProps<BaseProgressBarProps>(), { progress: 0 })
const translateX = computed(() =>
  Math.max(0, Math.min(100, (1 - props.progress) * 100)),
)
</script>
